import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

/**
 * KZT1 (Казахстан) API
 * Оплата через P2P перевод в тенге
 */

export const fetchKztConfig = async () => {
  try {
    const response = await apiService.makeRequest('/api/kzt1/')

    if (response.kzt) {
      return response.kzt
    }

    throw new Error('Invalid response format: kzt config not found')
  } catch (error) {
    console.error('Error fetching KZT config:', error)
    throw error
  }
}

export const fetchKztPackages = async () => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    if (response.topup && Array.isArray(response.topup)) {
      return response.topup.filter((pkg) => pkg.kzt1 !== undefined)
    }

    throw new Error('Invalid response format: topup array not found')
  } catch (error) {
    console.error('Error fetching KZT packages:', error)
    throw error
  }
}

const normalizeKztCreateError = (response) => {
  if (!response?.error) return null

  if (response.error === 'error sum') return 'INVALID_AMOUNT'
  if (response.error === 'error backend') return 'BACKEND_ERROR'
  if (response.error === 'Limit order. Please wait.') return 'LIMIT_ORDER'

  return response.error
}

export const createPaymentByKzt = async (kzt) => {
  try {
    const response = await apiService.makeRequest('/api/kzt1/', {
      method: 'POST',
      body: JSON.stringify({ kzt })
    })

    const normalizedError = normalizeKztCreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating KZT payment by kzt:', error)
    throw error
  }
}

export const openKztPayment = (paymentLink, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(paymentLink, onRedirect, 'KZT', paymentWindow)
}

export default {
  fetchKztConfig,
  fetchKztPackages,
  createPaymentByKzt,
  openKztPayment
}
